module.exports = __webpack_public_path__ + "img/createSeller9.1baba7fd.svg";